import { type ComponentType, lazy } from "react"

// biome-ignore lint/suspicious/noExplicitAny: components accept specific record subtypes, type safety is ensured by discriminator dispatch
type NotificationRenderer = ComponentType<{ notification: any }>

type LazyImport = () => Promise<{ default: NotificationRenderer }>

const renderers = new Map<string, NotificationRenderer>()
const loaders = new Map<string, LazyImport>()

export function registerLazyNotificationRenderer(
	type: string,
	loader: LazyImport,
): void {
	renderers.set(type, lazy(loader))
	loaders.set(type, loader)
}

export function getNotificationRenderer(
	type: string,
): NotificationRenderer | undefined {
	return renderers.get(type)
}

/** Preloads one type's renderer chunk so it renders without a lazy-load gap. Idempotent; a failed preload is non-fatal (React.lazy retries on render). */
export function preloadNotificationRenderer(type: string): void {
	const load = loaders.get(type)
	load?.().catch(() => {})
}
